import React, { PureComponent } from 'react';
import { ExpansionalPanel } from '../../../../ExpansionPanel';
import { connect } from 'react-redux';
import _ from 'lodash';
import getChapterNumber from '../../../../treeComponents/helper/getChapterNumber';
interface ConceptNodeProps {
  data: any;
  chapterNumber: string;
  subjectTab: any;
  viewPlanData: any;
  childIndex:number;
  treeData:any;
}

interface ConceptNodeState {
  hasContent: boolean;
  isOpen: boolean;
}

class ConceptNode extends PureComponent<ConceptNodeProps, ConceptNodeState> {
  constructor(props: ConceptNodeProps) {
    super(props);
    this.state = {
      hasContent: this.props.data.content.length ? true : false,
      isOpen: true,
    };
  }

  handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  componentWillUnmount() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }
  render = () => {
    const { data, chapterNumber, subjectTab, viewPlanData,childIndex,treeData } = this.props;
    const { name = '', conceptIndex, chapterIndex, content } = data;
    const showChapters=_.get(viewPlanData,'displaySettings.showChapters',true);
    const showTestVisibility=_.get(viewPlanData,'displaySettings.showTestVisibility',false);
    return (
      <div>
        <ExpansionalPanel
          isAddContentRequired={false}
          isAddBonusContentRequired={false}
          data={content}
          name={`${childIndex + 1}${'. ' + name}`}
          showTestVisibility={showTestVisibility}
        />

        {showChapters && !data.hideChapterLevel && data.chapterContent && Boolean(data.chapterContent.length) && (
          <div
            style={{
              borderTop: '1px solid lightgrey',
              marginLeft: '-75px',
              marginRight: '-28px',
              marginTop: '20px',
              paddingLeft: '70px',
              paddingRight: '27px',
            }}
          >
            <ExpansionalPanel
              name='Chapter Level Content'
              data={data.chapterContent}
              isBulkDataAdded={data.isBulkAdded}
              showTestVisibility={showTestVisibility}
            />
          </div>
        )}
      </div>
    );
  };
}

const mapStateToProps = (state: any) => ({
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
});

// export default ConceptNode;
// @ts-ignore
export default connect(mapStateToProps)(ConceptNode);
